import http from '../../Http-common';

const getAll = (roomId, typeId) => {
    return http.get(`/admin/subTopics?roomId=${roomId}&typeId=${typeId}`);
}

const getById = (id) => {
    return http.get(`/admin/audio?id=${id}`);
}

const create = (data) => {
    return http.post(`/admin/audio`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });
}

const updateSeq = (data) => {
    return http.post('/admin/updateSequence', data);
}

const deleted = (ids) => {
    return http.delete(`/admin/audio?ids=${ids}`);
}

const AudioService = {
    getAll,
    getById,
    create,
    updateSeq,
    deleted,
}

export default AudioService;